

export const index = 2;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(app)/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/2.ClivPMj4.js","_app/immutable/chunks/disclose-version.BiGnJ2-v.js","_app/immutable/chunks/runtime.r6XFBCAP.js","_app/immutable/chunks/legacy.5Vd76dO9.js","_app/immutable/chunks/slot.CwiXRjvo.js","_app/immutable/chunks/entry.-fmvyePh.js","_app/immutable/chunks/index-client.D85crPKC.js","_app/immutable/chunks/index.BLdWbiDd.js"];
export const stylesheets = [];
export const fonts = [];
